import {
    useClientLimitedEvents,
} from "@twigsby/client-data";

const DataPreFetcher = () => {
    const { data: eventsData } = useClientLimitedEvents();

    return (
        <></>
    )
}

export { DataPreFetcher }
